import { gql } from "@apollo/client";

export const USER_QUERY = gql`
 query Me {
    me {
        id
        email
        firstName
        lastName
        role
        companyId
        schema
        subdomain
        phoneNumber
        countryCode  
        twoFactorEnabled
    }
}
`;

// Companies Query

export const IS_EMAIL_AVAILABLE_QUERY = gql`
  query IsEmailAvailable($email: String!) {
    isEmailAvailable(email: $email)
  }
`;
